













































import { Component, Vue, Watch,Prop } from 'vue-property-decorator';
import dayjs from "dayjs";
@Component({
    components: {
      
    },
})
export default class logoutPanel extends Vue {
    public $refs: {
    };
    @Prop({
        default:false
    }) 
    show:Boolean;
    @Prop({
        default:""
    }) 
    title:String;
    @Prop({
        default:""
    }) 
    text:String;
    @Prop({
        default:""
    }) 
    confirmText:String;
    @Prop({
        default:""
    }) 
    cancelText:String;
    @Prop({
        default:1
    }) 
    btnNums:Number;

    bqcheck = true;
    xpcheck = true;

    @Watch("show")
    showChange(val){
        console.log('val',val);
        if(val){
            console.log(333);
            this.bqcheck = true;
            this.xpcheck = true;
        }
    }

    created() {
        
    }
    mounted() {
        
    }

    confimrFun(){
        let obj = {
            val1:this.bqcheck,
            val2:this.xpcheck
        }
        this.$emit("confimrFun",obj);
    }

    cancelFun(){
        this.$emit("cancelFun");
    }

    
   
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/components/pad/logoutPanel1.vue